import './ThankYou.scss'

import React, {Component} from 'react';

import { connect } from 'react-redux'
import { push } from 'react-router-redux'

class ThankYou extends Component {

  render() {
    return (
      <div className="ThankYou" onload={ setTimeout( () => { window.location = '/' }, 5000) } >
        <div className="ThankYou__content">
          <div className="ThankYou__title">Thank You</div>
          <div className="ThankYou__subtitle">Your account has been reactivated.</div>
          <div className="ThankYou__return-button">
            <button  onClick={() => { window.location = '/' } }>Return Home</button>
          </div>
        </div>
      </div>
    )
  }

}

export default ThankYou
